<template>
    <div class="text" v-html="text" @click="draw"></div>
</template>
<script>
/* eslint-disable vue/multi-word-component-names */
import { isLogin } from '../../utils';

export default {
    props: {
        text: {
            type: String,
            default: ''
        },
        remain: {
            type: Number,
            default: 0
        },
        drawCb: {
            // 抽奖回调
            type: Function,
            require: true
        },
        drawSuccessCb: {
            // 抽奖成功回调
            type: Function
        },
        drawFailCb: {
            // 抽奖失败回调
            type: Function
        },
        noRemainCb: {
            // 无抽奖机会的回调
            type: Function
        },
        noLoginCb: {
            // 未登录时点击按钮
            type: Function
        },
    },
    data() {
        return {
        };
    },
    methods: {
        /**
         * 抽奖
         */
        async draw() {
            // 未登录
            if (!isLogin) {
                if (this.noLoginCb) {
                    this.noLoginCb();
                }
                return;
            }
            // 没有抽奖机会
            if (!this.remain) {
                if (this.noRemainCb) {
                    this.noRemainCb();
                }
                return;
            }
            try {
                // 抽奖
                const res = await this.drawCb();
                this.drawSuccessCb(res);
            } catch (error) {
                this.drawFailCb(error);
            }
        },
    }
};
</script>
<style lang="less" scoped>
</style>
